import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M2.5 9.5H21.5V20.5C21.5 21.0523 21.0523 21.5 20.5 21.5H3.5C2.94772 21.5 2.5 21.0523 2.5 20.5V9.5Z\" fill=\"#6841EA\" stroke=\"#6841EA\" stroke-width=\"2\" stroke-linejoin=\"round\"></path><path d=\"M2.5 5C2.5 4.44772 2.94772 4 3.5 4H20.5C21.0523 4 21.5 4.44772 21.5 5V9.5H2.5V5Z\" stroke=\"#6841EA\" stroke-width=\"2\" stroke-linejoin=\"round\"></path><path d=\"M8 15.5L11 18.5L17 12.5\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8 2.5V6.5\" stroke=\"#6841EA\" stroke-width=\"2\" stroke-linecap=\"round\"></path><path d=\"M16 2.5V6.5\" stroke=\"#6841EA\" stroke-width=\"2\" stroke-linecap=\"round\"></path>", 5)
  ])))
}
export default { render: render }